"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactIconBase = _interopRequireDefault(require("react-icon-base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CategoryCodeCOMT = function CategoryCodeCOMT(props) {
  return _react.default.createElement(_reactIconBase.default, _extends({
    viewBox: "0 0 16 16"
  }, props), _react.default.createElement("g", null, _react.default.createElement("title", null, "CategoryCodeCOMT"), _react.default.createElement("g", null, _react.default.createElement("path", {
    d: "M13.673,5.266H11.294V8.539A1.343,1.343,0,0,1,9.953,9.881H5.72v1.2a.328.328,0,0,0,.327.327h5.735a.33.33,0,0,1,.25.115l1.392,1.637A.327.327,0,0,0,14,12.943V5.593A.327.327,0,0,0,13.673,5.266Z"
  }), _react.default.createElement("path", {
    d: "M9.953,8.866a.327.327,0,0,0,.327-.327V3.057a.327.327,0,0,0-.327-.327H2.327A.326.326,0,0,0,2,3.057v7.349a.327.327,0,0,0,.33.328.318.318,0,0,0,.246-.116L3.968,8.981a.33.33,0,0,1,.25-.115Z"
  }))));
};

var _default = CategoryCodeCOMT;
exports.default = _default;